import type { BaremetalServer } from '@/entities/baremetal';
import request from '@/shared/api/request';

export const resetBaremetalPassword = (
  id: number,
  password: string,
): Promise<{ baremetal: BaremetalServer }> =>
  request({
    url: `/baremetals/${id}/`,
    method: 'POST',
    data: { action: 'reset_password', password },
  });
